import React, { Component } from "react";
import { v4 as uuid } from "uuid";

import Modal from "react-bootstrap/Modal";

import UBXButton from "./../../ubx/button";

export default class ConfirmModal extends Component {
    onOpen() {
        const { onOpen = false } = this.props;

        if (onOpen) {
            onOpen();
        }
    }

    onClose() {
        const { onClose = false } = this.props;

        if (onClose) {
            onClose();
        }
    }

    onDecline(e) {
        if (e) {
            e.preventDefault();
        }
        const { onDecline = false } = this.props;

        if (onDecline) {
            onDecline(e);
        }

        this.onClose();

        return false;
    }

    onAgree(e) {
        if (e) {
            e.preventDefault();
        }
        const { onAgree = false } = this.props;

        if (onAgree) {
            onAgree(e);
        }

        this.onClose();

        return false;
    }

    renderBody() {
        const { children = [] } = this.props;

        return (
            <Modal.Body>
                <div className="confirm-content">{children}</div>
            </Modal.Body>
        );
    }

    renderFooter() {
        const { onAgree = false, onDecline = false, agreeText = "Ok", declineText = "Cancel" } = this.props;
        const buttons = [];

        if (onDecline) {
            buttons.push(
                <UBXButton
                    key={"decline-button"}
                    className="decline"
                    type="secondary"
                    block="sm"
                    size="small"
                    onClick={(e) => this.onDecline(e)}
                >
                    {declineText}
                </UBXButton>,
            );
        }

        if (onAgree) {
            buttons.push(
                <UBXButton
                    key={"agree-button"}
                    className="agree"
                    type="primary"
                    block="sm"
                    size="small"
                    onClick={(e) => this.onAgree(e)}
                >
                    {agreeText}
                </UBXButton>,
            );
        }

        return <Modal.Footer>{buttons}</Modal.Footer>;
    }

    render() {
        const { id = `confirm-${uuid()}`, show, className = "" } = this.props;

        return (
            <Modal
                id={id}
                className={`confirm-modal ${className}`}
                show={show}
                backdrop="static"
                centered
                onShow={() => this.onOpen()}
                onHide={() => this.onClose()}
            >
                <Modal.Header closeButton closeLabel="Close Confirm Modal"></Modal.Header>
                {this.renderBody()}
                {this.renderFooter()}
            </Modal>
        );
    }
}
